import GeoSchema from '@/components/Schema/GeoSchema/GeoSchema';
import OrganizationSchema from '@/components/Schema/OrganizationSchema/OrganizationSchema';
import { Section } from '@/components/Section/Section';
import SkipToContent from '@/components/SkipToContent/SkipToContent';
import type {
  EnhancedStandardPageContent,
  Seo,
} from '@/contentful/contentful-exports';
import FooterComponent from '../Layout/Footer/Footer';
import HeaderComponent from '../Layout/Header/Header';
import FAQPageSchema from '../Schema/FAQPageSchema/FAQPageSchema';

interface Props {
  content: EnhancedStandardPageContent;
  path: string;
  seoFields?: Seo;
}

export default function StandardPage({
  content: {
    fields: { header, footer, sections },
  },
  path,
  seoFields,
}: Props) {
  return (
    <>
      <OrganizationSchema />
      <GeoSchema path={path} seoFields={seoFields} sections={sections} />
      <FAQPageSchema sections={sections} />
      <SkipToContent href='#main' />
      <HeaderComponent header={header} />
      {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
      <main style={{ backgroundColor: 'black' }} id='main'>
        {sections.map((section, index) => (
          <Section
            key={section.sys.id}
            section={section}
            sectionPosition={index}
          />
        ))}
      </main>
      <FooterComponent footer={footer} />
    </>
  );
}
